/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {

  // MAIN CATEGORY
  fetchCategoriesMain({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/admin/cockpit/categories/main")
        .then((response) => {
          commit('SET_CATEGORIES_MAIN', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateCategoryMain({ commit } , data) {
    return new Promise((resolve, reject) => {
      axios.post(`/api/admin/cockpit/categories/main/update/${data.id}` , data.data)
        .then((response) => {
          commit('SET_CATEGORIES_MAIN', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addNewCategoryMain({ commit } , data) {
    return new Promise((resolve, reject) => {
      axios.post(`/api/admin/cockpit/categories/main/new` , data)
        .then((response) => {
          commit('SET_CATEGORIES_MAIN', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  // THEMATIC CATEGORY

  fetchCategoriesThematic({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/admin/cockpit/categories/thematic")
        .then((response) => {
          commit('SET_CATEGORIES_THEMATIC', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateCategoryThematic({ commit } , data) {
    return new Promise((resolve, reject) => {
      axios.put(`/api/admin/cockpit/categories/thematic/update/${data.id}` , data)
        .then((response) => {
          commit('SET_CATEGORIES_THEMATIC', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addNewCategoryThematic({ commit } , data) {
    return new Promise((resolve, reject) => {
      axios.post(`/api/admin/cockpit/categories/thematic/new` , data)
        .then((response) => {
          commit('SET_CATEGORIES_THEMATIC', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }

}
